import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Overlay from 'componentsV2/Hero/components/Overlay';
import HeroBackground from 'componentsV2/Hero/components/HeroBackground';
import ActionButtons from 'componentsV2/ActionButtons';
import Modal from 'componentsV2/Hero/components/Modal';
import ContextPlayer from 'components/ContextPlayer';
import Description from 'componentsV2/Hero/components/SeriesDescription';
import Headline from 'componentsV2/Headline';
import Logo from 'componentsV2/Logo';
import Metadata from 'componentsV2/Hero/components/Metadata';
import ProgressBar from 'componentsV2/ProgressBar';
import { AnonymousSeriesProcessorV2 } from '../../processors';
import style from './AnonymousSeriesV2View.module.scss';

const AnonymousSeries = ({
  account,
  analytics,
  bookmarks,
  continueWatchingItems,
  disableScroll = () => {},
  item,
  showUpgradeCTA,
}) => {
  const [playerVisibility, setPlayerVisibility] = useState(false);
  const [showModal, toggleModal] = useState(false);
  const { activePlans } = useSelector(state => state?.app);
  const {
    backgroundProps,
    buttonArray,
    descriptionProps,
    logoProps,
    metaData,
    playerProps,
    progressProps,
    title,
  } = AnonymousSeriesProcessorV2({
    activePlans,
    additionalFunctions: { setPlayerVisibility, disableScroll },
    analytics,
    bookmarks,
    continueWatchingItems,
    panel: item,
    playerVisibility,
    showUpgradeCTA,
  });

  return (
    <>
      <ContextPlayer
        {...playerProps}
        account={account}
        theme={style}
        visibility={playerVisibility}
      />
      <Modal
        {...descriptionProps}
        theme={style}
        showModal={showModal}
        toggleModal={toggleModal}
        disableScroll={disableScroll}
      />
      <HeroBackground theme={style} {...backgroundProps}>
        <Overlay theme={style}>
          <Logo theme={style} isSeries={backgroundProps?.isSeries} {...logoProps} />
          <Headline theme={style} text={title} />
          <Description
            theme={style}
            {...descriptionProps}
            toggleModal={toggleModal}
            disableScroll={disableScroll}
          />
          <Metadata theme={style} {...metaData} />
          <ProgressBar {...progressProps} theme={style} />
          <ActionButtons buttons={buttonArray} theme={style} />
        </Overlay>
      </HeroBackground>
    </>
  );
};

AnonymousSeries.propTypes = {
  account: PropTypes.shape({}),
  analytics: PropTypes.shape({}).isRequired,
  bookmarks: PropTypes.shape({}),
  continueWatchingItems: PropTypes.shape({}),
  disableScroll: PropTypes.func,
  item: PropTypes.shape({}),
  showUpgradeCTA: PropTypes.bool,
};

export default AnonymousSeries;
